import { PdpReviewForm } from 'features/review-form/review-form-connected';
import React from 'react';
import { Breakpoint } from 'types/utils';
import { MediaQueries } from 'utils/internal-specifics/media-queries';
import { addMediaQueryHandlers } from 'utils/add-media-query-handlers';

export const ReviewsFormContent: React.FC = () => {
  const [breakpoint, setBreakpoint] = React.useState<Breakpoint>('large');

  React.useEffect(
    () =>
      addMediaQueryHandlers(
        [
          MediaQueries.LARGE_DESK_SCREEN,
          MediaQueries.MEDIUM_DESK_SCREEN,
          MediaQueries.TABLET_SCREEN,
          MediaQueries.MOBILE_SCREEN,
        ],
        ['large', 'medium', 'tablet', 'mobile'],
        'large',
        setBreakpoint,
      ),
    [],
  );

  return (
    <>
      <PdpReviewForm breakpoint={breakpoint} />
    </>
  );
};
